import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { CALENDAR_SETTINGS_ROUTES } from "./modules/constants";
import { getIsCalendar2Enabled } from "./modules/featureFlags";
import { EventTypes, Events, SchoolWiseInformation } from "./routes";

const routesWithSideNav = () => ({
  path: "",
  component: withAsyncRouteLoading(() =>
    import(
      /* webpackChunkName: "calendar-settings-sidenav-outlet" */ "./components/SideNavigationOutlet"
    ).then(m => m.default)
  ),
  indexRoute: {
    component: null,
  },
  childRoutes: [EventTypes(), Events(), SchoolWiseInformation()],
});

export default store => ({
  path: CALENDAR_SETTINGS_ROUTES.BASE_ROUTE,
  onEnter: (nextState, replace) => {
    if (!getIsCalendar2Enabled()) {
      replace("/accountSettings");
    }
  },
  component: withAsyncRouteLoading(() =>
    import(
      /* webpackChunkName: "calendar-settings" */ "./components/CalendarSettings"
    ).then(m => m.default)
  ),
  childRoutes: [routesWithSideNav()],
});
